

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAxfHOcJS_UAY3Vo04nRH0nmIumXHb7LlA",
  authDomain: "e-learning-9faa2.firebaseapp.com",
  projectId: "e-learning-9faa2",
  storageBucket: "e-learning-9faa2.appspot.com",
  messagingSenderId: "795127428670",
  appId: "1:795127428670:web:7555a85bdba5f40294036f"
};

export default firebaseConfig;